// extracted by mini-css-extract-plugin
export default {"currentSetting":"G238e62"};